export default function wpCaseRegexPostInit() {

  class WpRegex {
    constructor(data) {
      this.data =  (() => {
        let converList = data.map(wpDataItem => {
          wpDataItem.regexData = this.replaceCommasWithVerticalBars(this.sanitize(wpDataItem.search_grade)) || null;
          wpDataItem.caseSuggestRegexData = this.replaceCommasWithVerticalBars(this.sanitize(wpDataItem.case_suggest_list)) || null;
          if( wpDataItem.caseSuggestRegexData === "null" ){
            wpDataItem.caseSuggestRegexData = wpDataItem.title;
          }else{
            wpDataItem.caseSuggestRegexData += "|" + wpDataItem.title;
          }
          return wpDataItem;
        });
        return converList;
      })();
    }

    matchesAnyRegex(inputString) {
      if (typeof inputString !== 'string') throw new Error('Input must be a string');
    
      const matchingData = [];
    
      // regexListの各正規表現に対してマッチングを試行し、マッチしたものを配列に追加
      for (const wpDataItem of this.data) {
        if (wpDataItem.regexData !== null) {
          const regex = new RegExp(wpDataItem.regexData);
          if (regex.test(inputString)) {
            matchingData.push(wpDataItem);
          }
        }
      }
    
      // マッチした正規表現の配列を返す
      return matchingData;
    }

    sanitize = (str) => {
      return String(str).replace(/&/g, "&amp;")
        .replace(/"/g, "&quot;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/　/g, " ");
    }
    replaceCommasWithVerticalBars(inputString) {
      if (typeof inputString !== 'string') throw new Error('Input must be a string');

      const replacedString = inputString.replace(/,/g, '|');
      return replacedString;
    }
  }


  return new Promise(async (resolve, reject) => {
    try {
      const main = document.getElementById("js__main") || {};
      const nonce = main.getAttribute("data-nonce");
      const isHTTPS = window.location.protocol === "https:";
      const ajaxUrl = `${isHTTPS ? "https://" : "http://"}${window.location.host}/wp-admin/admin-ajax.php`;

      const data = new URLSearchParams();
      data.append("action", "get_case_ajax");
      data.append("nonce", nonce);

      const response = await fetch(ajaxUrl, {
        method: "POST",
        body: data,
      });

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const responseData = await response.json();
      const regexClassInstance = new WpRegex(responseData);

      resolve(regexClassInstance);
    } catch (error) {
      console.error("Error:", error);
      reject(error);
    }
  });
}